import React from 'react';
import {FormControl, InputAdornment, InputLabel, Stack} from '@mui/material';
import {LocalizationProvider, TimePicker} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {es as esLocale} from 'date-fns/locale';
import {FORMATS} from '../../../constants';
import {PtrnCampoEditableTime} from '../../../patronTypes';
import {PtrnPropsUtil} from '../../../patronUtils';
import {EditableProps} from '../campoEditableTypes';
import {useInputStyles} from '../campoEditableUtils';
import {parse} from 'date-fns';
function CampoEditableTime(
   props: {campoConfig: PtrnCampoEditableTime} & EditableProps & {
         ErrorComponent?: React.ReactNode;
      }
) {
   const {campoConfig, ...editableProps} = props;
   const classes = useInputStyles();

   const auxParam = {
      camposData: editableProps.camposData,
      campoConfig: campoConfig,
      ptrnRef: editableProps.ptrnRef,
      ruta: editableProps.ruta,
      index: editableProps.index
   };

   const handleChange = (newValue: Date | null) => {
      editableProps.onChange(campoConfig.name, newValue, auxParam);
   };

   const id = PtrnPropsUtil.genIdCampoEditable(campoConfig);
   const errorAdornments = props.ErrorComponent ? props.ErrorComponent : undefined;
   const handleOnBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
      if (editableProps.onBlur) {
         const name = e.target.name;
         const dateStr = e.target.value;
         const newValue = parse(dateStr, FORMATS.time, new Date());
         editableProps.onBlur(name, newValue, auxParam);
      }
   };
   // Helper function to merge adornments
   const mergeAdornments = (...adornments: React.ReactNode[]) => {
      const nonNullAdornments = adornments.filter((el) => el != null);
      if (nonNullAdornments.length === 0) {
         return null;
      }

      if (nonNullAdornments.length === 1) {
         return nonNullAdornments[0];
      }

      return (
         <Stack direction="row" spacing={1} alignItems="center">
            {nonNullAdornments.map((adornment, index) => (
               <React.Fragment key={index}>{adornment}</React.Fragment>
            ))}
         </Stack>
      );
   };
   return (
      <FormControl fullWidth error={Boolean(props.ErrorComponent)}>
         <InputLabel htmlFor={id}></InputLabel>
         <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
            <TimePicker
               name={campoConfig.name}
               value={editableProps.value}
               onChange={handleChange}
               label={campoConfig.label}
               minTime={campoConfig.minTime}
               format={FORMATS.time}
               maxTime={campoConfig.maxTime}
               minutesStep={campoConfig.minutesStep}
               views={campoConfig.views}
               slotProps={{
                  textField: (params) => ({
                     ...params,
                     size: 'small',
                     InputProps: {
                        ...params.InputProps,
                        error: Boolean(props.ErrorComponent),
                        // Use the mergeAdornments function to combine both adornments
                        endAdornment: mergeAdornments(
                           errorAdornments,
                           params.InputProps?.endAdornment
                        ),
                        onBlur: handleOnBlur
                     }
                  })
               }}
               formatDensity="dense"
            />
         </LocalizationProvider>
      </FormControl>
   );
}

export default CampoEditableTime;
